export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=706f8b57b966596c11a44a1b0000a400a964b92dcb&name=pushAdClickData!'